import _ from "lodash";
import React, { createRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import NextArrow from "../../LearningPaths/NextArrow";
import PrevArrow from "../../LearningPaths/PrevArrow";
import Pagination from "../../../pages/Orders/Pagination";
import exportFromJSON from "export-from-json";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import PieChart from "../../Layouts/Graphs/PieChart";
import ReportGraphSection from "../ReportGraphSection";
import { SessionKeys } from "../../../utils/AppUtils";

import moment from "moment";
import PaginationProgress from "../progressReport/PaginationProgress";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";
import { useTranslation } from "react-i18next";
const fileName = "SystemUsageReport";
const exportType = "xls";
// let PageSize = 20;
const sliderRef = createRef();
const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  swipe: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const ReportTableSystemUsage = (props) => {
  const {
    setSearchInput,
    getFilteredData,
    setIsLoading,
    isLoading,
    isView,
    statusFilterData,
    setCanShow,
    type,
    profileReports,
    lpName,
    message,
    searchTable,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector((state) => state.report.anyTotalReport);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);
  // const [profileReports, setProfileReports] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [progressSort, setProgressSort] = useState("asc");
  const [searchedText, setsearchedText] = useState("");
  const [officeLabel, setOfficeLabel] = useState("");
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel(t("Office Name"));
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel(t("Office Name"));
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    setCurrentPage(1);
  }, [profileReports]);

  const currentTableData = useMemo(() => {
    if (profileReports !== null) {
      console.log(profileReports);
      let reportsData = _.clone(profileReports);
      console.log(reportsData);
      reportsData = _.sortBy(reportsData, "progress");
      if (progressSort === "desc") {
        reportsData = _.reverse(reportsData);
      }
      console.log(reportsData);
      const firstPageIndex = (currentPage - 1) * pageSize;
      const lastPageIndex = firstPageIndex + pageSize;
      setCanShow(true);
      console.log(reportsData);
      return reportsData.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, profileReports, progressSort, pageSize]);

  const ExportToExcel = () => {
    const data = _.cloneDeep(profileReports);
    for (let item of data) {
      item.status =
        item?.status === "In Progress"
          ? "In Progress"
          : item?.status === "NotStarted"
          ? "Yet to start"
          : "Completed";
      item.progress =
        item?.progress !== undefined && item?.progress !== ""
          ? item?.progress + "%"
          : "-";
      item.completion_date =
        item?.completion_date !== undefined && item?.completion_date !== ""
          ? moment(
              StaticUtils.getDateFromTimeStamp(item?.completion_date),
              "MM/DD/YYYY"
            ).format("DD MMM, YYYY")
          : "-";
    }

    let tempArr = [];
    for (const item of data) {
      let obj = {
        username: item.username,
        email: item.email,
        office_name: item.office_name,
        status: item.status,
        progress: item.progress,
        completion_date: item.completion_date,
      };
      tempArr.push(obj);
    }

    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "username":
              return "Name";
            case "email":
              return "Email";
            case "office_name":
              return { officeLabel };
            case "status":
              return "Status";
            case "progress":
              return "% Progress";
            case "completion_date":
              return "Date of Completion";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: "CodeOfEthicsReport",
      report: newThing,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj)
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };

  function formatDate(inputDate) {
    // const dateParts = inputDate.split("/");

    // // Check if the date format is valid
    // if (dateParts.length !== 3) {
    //   return "";
    // }

    // const formattedDate = new Date(
    //   `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
    // );

    // // Check if the constructed date is valid
    // if (isNaN(formattedDate.getTime())) {
    //   return "";
    // }

    // const day = formattedDate.getDate();
    // const monthNames = [
    //   "Jan",
    //   "Feb",
    //   "Mar",
    //   "Apr",
    //   "May",
    //   "Jun",
    //   "Jul",
    //   "Aug",
    //   "Sep",
    //   "Oct",
    //   "Nov",
    //   "Dec",
    // ];
    // const monthIndex = formattedDate.getMonth();
    // const year = formattedDate.getFullYear();

    // const formattedString = `${day} ${monthNames[monthIndex]}, ${year}`;

    // return formattedString;
    const formattedDate = moment(inputDate, "MM/DD/YYYY").format(
      "MMM DD, YYYY"
    );
    return formattedDate;
  }

  const renderTableReport = () => {
    return (
      <div className="row list-coach report-table-rsp">
        <div className="col-lg-12 col-md-12">
          <div className="table-responsive-usage">
            <div className="tablebox">
              <table className="table mb-0 office_list table-striped">
                <thead>
                  <tr>
                    <th className="office-province">{t("First Name")}</th>
                    <th className="office-province">{t("Last Name")}</th>
                    <th className="office-province">{t("Role")}</th>
                    <th className="office-province">{t("Email")}</th>
                    <th className="office-province">{officeLabel}</th>
                    {/* <th className="office-province">{t("TeamManager")}</th> */}
                    <th className="office-province">{t("Status")}</th>
                    <th className="office-province">
                      {t("Last LoggedIn Date")}
                    </th>
                    <th className="office-province">
                      {t("User Created Date")}
                    </th>
                    {/* <th className="office-province">
                      {t("User Activation Date")}
                    </th> */}
                    <th className="office-province">{t("Date of Hiring")}</th>
                    {false && (
                      <th className="office-province">{t("Hire Source")}</th>
                    )}
                    {/* <th className="office-province">{t("Remarks")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {currentTableData?.map((item, index) => {
                    return (
                      <tr className="addBGcustomw">
                        <td>{item?.first_name}</td>
                        <td>{item?.last_name}</td>
                        <td>
                          {" "}
                          {item?.role === "Real Estate Agent"
                            ? "End user"
                            : item?.role === "Manager"
                            ? "Team Manager"
                            : item?.role === "External Instructor"
                            ? "External Trainer"
                            : item?.role}
                        </td>
                        <td>{item?.user_email}</td>
                        <td>
                          {item?.office.map((name, index) =>
                            item?.office.length === 1
                              ? `${name}`
                              : item?.office.length === index + 1
                              ? `${name}`
                              : `${name}, `
                          )}
                        </td>
                        {/* {item?.manager ? (
                          <td> {item?.manager} </td>
                        ) : (
                          <td className="text-left"> {"-"} </td>
                        )} */}
                        <td>{item?.status}</td>
                        {/* <td>{item.last_login ? formatDate(item.last_login) : '-'}</td> */}
                        {item?.last_login ? (
                          <td> {formatDate(item?.last_login)} </td>
                        ) : (
                          <td className="text-left"> {"-"} </td>
                        )}
                        {item?.created_at ? (
                          <td> {formatDate(item?.created_at)} </td>
                        ) : (
                          <td className="text-left"> {"-"} </td>
                        )}
                        {/* {item?.activation_date ? (
                          <td> {formatDate(item?.activation_date)} </td>
                        ) : (
                          <td className="text-left"> {"-"} </td>
                        )} */}
                        {item?.date_of_joining ? (
                          <td> {formatDate(item?.date_of_joining)} </td>
                        ) : (
                          <td className="text-left"> {"-"} </td>
                        )}

                        {/* <td className="text-center"> {item.hire_source} </td>
                                                <td className="text-center"> {item.remarks} </td> */}
                        {/* {item?.hire_source ? (
                          <td>
                            {" "}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.hire_source,
                              }}
                            ></div>{" "}
                          </td>
                        ) : (
                          <td className="text-center">--</td>
                        )} */}
                        {/* {item?.remarks ? (
                          <td>
                            {" "}
                            <div
                              dangerouslySetInnerHTML={{ __html: item.remarks }}
                            ></div>{" "}
                          </td>
                        ) : (
                          <td className="text-left">--</td>
                        )} */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="pagetab d-flex justify-content-center gap-2 mt-3 align-items-center mb-5">
              <div className="input-lear">
                <select
                  className="form-select input_searchfield mb-0 pe-5"
                  onChange={(evt) => {
                    setCurrentPage(1);
                    setPageSize(_.toNumber(evt.target.value));
                    // resetAllSelection();
                  }}
                >
                  <option selected={pageSize === 20} value="20">
                    20
                  </option>
                  <option selected={pageSize === 50} value="50">
                    50
                  </option>
                  <option selected={pageSize === 100} value="100">
                    100
                  </option>
                </select>
              </div>
              <span className="rosetext">{t("rows per page")}</span>
              <PaginationProgress
                className="pagination-bar m-0"
                currentPage={currentPage}
                totalCount={profileReports?.length}
                pageSize={pageSize}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderGraphReport = () => {
    return (
      <ReportGraphSection
        series={series}
        legends={legends}
        isLoading={isLoading}
        type={type}
        isAmount={false}
      />
    );
  };

  return (
    <>
      <section className="table-report-layout mt-rem">
        {true ? (
          <div className="container-pwc">
            <div className="row">
              <div className="col-md-12">
                <div className="table-head">{t("Details")}</div>
              </div>

              <div className="col-md-12 search__input mb-4">
                <div className="input-lear position-relative d-flex">
                  <label for="search" className="input__label">
                    {t("Search")}
                  </label>
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="input_searchfield_search mb-0"
                    autocomplete="off"
                    onChange={(evt) => {
                      if (!evt.target.value) searchTable("");
                      //setSearchInput(evt.target.value)
                      setsearchedText(evt.target.value);
                    }}
                  />
                  <button
                    className="button-reset"
                    onClick={() => {
                      searchTable(searchedText);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="Find"
                      width="28"
                      height="28"
                      viewBox="0 0 30 30"
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradient"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stop-color="#415385" />
                          <stop offset="1" stop-color="#415385" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_191"
                        data-name="Ellipse 191"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradient)"
                      />
                      <circle
                        id="Ellipse_192"
                        data-name="Ellipse 192"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-search"
                        data-name="Icon awesome-search"
                        d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                        transform="translate(7.715 7.714)"
                        fill="#415385"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {currentTableData && currentTableData?.length > 0 ? (
              renderTableReport()
            ) : profileReports !== null ? (
              <div className="not-found mt-3">
                <div className=" interboxes">
                  {/* <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" /> */}
                  <NotFoundImage />
                  <p>{message}</p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </section>
    </>
  );
};
export default ReportTableSystemUsage;
